import script from "./UIBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIBtn.vue?vue&type=script&lang=ts&setup=true"

import "./UIBtn.vue?vue&type=style&index=0&id=a5c158b4&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/2024-mcdo-gamecenter-wrapper/2024-mcdo-gamecenter-wrapper/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5c158b4"]])

export default __exports__